import React, { useRef } from 'react';

import PageScrollerNavigation from './PageScrollerNavigation';

import DivButton from 'components/common/DivButton';
import useGlobalState from 'crm/GlobalStateContext';
import { getTemplateName } from 'utils/template';

type Props = Readonly<{
    topLogoVisible: boolean;
    leftNavbarHidden: boolean;
    mobileNavbarVisible: boolean;
    toggleLeftNavbar: () => void;
    toggleMobileNavbar: () => void;
}>;

function Header({
    topLogoVisible,
    leftNavbarHidden,
    mobileNavbarVisible,
    toggleLeftNavbar,
    toggleMobileNavbar,
}: Props) {
    const { pageScrollerList } = useGlobalState();
    const navbarSupportedContentRef = useRef<HTMLDivElement>();
    const hidePageScroller = () => navbarSupportedContentRef.current?.classList.remove('show');

    return (
        <header className="topbar" data-navbarbg="skin6">
            <nav className="navbar top-navbar navbar-expand-md navbar-light">
                <div className={`navbar-header shadow-sm ${topLogoVisible ? 'expand-logo' : ''}`} data-logobg="skin5">
                    <DivButton
                        className="nav-toggler waves-effect waves-light d-block d-md-none"
                        onClick={() => {
                            toggleMobileNavbar();
                            hidePageScroller();
                        }}
                    >
                        <i className={mobileNavbarVisible ? 'ti-close' : 'ti-menu'} />
                    </DivButton>
                    <div className="navbar-brand">
                        <a href="/" className="logo">
                            <b className="logo-icon main-logo-wrapper">
                                <img
                                    src={`/images/${getTemplateName()}/logo.png`}
                                    alt="homepage"
                                    className="light-logo img-fluid img-rounded"
                                />
                            </b>
                        </a>
                        <DivButton
                            className="sidebartoggler d-none d-md-block"
                            onClick={toggleLeftNavbar}
                            data-sidebartype="mini-sidebar"
                        >
                            <i
                                className={`cursor-pointer mdi mdi-toggle-switch font-20 ${
                                    leftNavbarHidden ? 'mdi-toggle-switch-off' : ''
                                }`}
                            />
                        </DivButton>
                    </div>
                    <div
                        className={`topbartoggler d-block d-md-none waves-effect waves-light collapsed ${
                            pageScrollerList.length <= 1 ? 'invisible' : ''
                        }`}
                        data-toggle="collapse"
                        data-target="#navbarSupportedContent"
                        aria-controls="navbarSupportedContent"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                    >
                        <i className="ti-more" />
                    </div>
                </div>
                <div
                    ref={navbarSupportedContentRef}
                    id="navbarSupportedContent"
                    className="navbar-collapse pr-0 collapse"
                    data-navbarbg="skin6"
                >
                    <div className="page-scroller-wrapper">
                        <PageScrollerNavigation onButtonClick={hidePageScroller} />
                    </div>
                </div>
            </nav>
        </header>
    );
}

export default Header;
